// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixData from 'wix-data';

$w.onReady(function () {
  $w("#myHtmlComponent").onMessage( (event) => {
    $w('#myText').html = event.data;
	let cc = {
		"rr": event.data
	}
wixData.insert("test",cc)
 .then( (results) => {
		let item = results; //see item below
	} )
	.catch( (err) => {
		let errorMsg = err;
	} );

// $w("#dataset1").setFieldValue("rr",  event.data);
// $w("#dataset1").save();
  } ); 
} );









let interval;
let timeInterval = 100;
let typeStr = "חפש סגולה בכל תחום וענין.";
let typeIdx;
let htmlStr = '';
let displayStr;

$w.onReady(function () {

	if (htmlStr.length === 0) {
		htmlStr = $w("#typewriterPage").html;
	}
	$w("#typewriterPage").html = ''; 
	let strPieces = htmlStr.split("!##!");

	displayStr = ''; 
	typeIdx = 0; 

	interval = setInterval(function () {
		displayStr = displayStr + typeStr[typeIdx++];
		$w("#typewriterPage").html = strPieces[0] + displayStr + strPieces[1];
		if (typeIdx === typeStr.length) clearInterval(interval);
	}, timeInterval);
});